import type { IntegrationSystem, ServiceCode } from '@/shared/types';
import type { ExternalImgPath } from '@/shared/ui';

export enum UserServicePaymentType {
  ONLINE = 'online',
  OFFLINE = 'offline',
  BOTH = 'both',
  WITHOUT_PAYMENT = 'without_payment',
}

export enum ServiceType {
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  OFFLINE = 'offline',
}

export interface UserService {
  id: string;
  name: string;
  type: ServiceType;
  source: Nullable<IntegrationSystem>;
  categories: number[];
  link: Nullable<string>;
  icon: ExternalImgPath;
  code: ServiceCode;
  withAuth: boolean;
  documentName: Nullable<string>;
  video_instruction?: string;

  isAvailable: boolean;
  paymentType: UserServicePaymentType | null;
  btn_cta: Nullable<string>;
  faq: Nullable<Array<[string, string]>>;
  captcha_is_enabled: boolean;
  is_hidden: boolean;
  sync_profile_available: boolean;
}

export interface UserServiceExternal {
  name: string;
  link: string;
  short_description: string;
  description: string;
  order: number;
  icon: ExternalImgPath;
}

export type ServiceCategory = {
  id: number;
  name: string;
  slug: string;
  description: string;
};
